import '../index.css'

export interface InfoPageData {
  title: string
  contents: {
    header: string
    body: string[]
  }[]
}

interface Props {
  title: string
  contents: {
    header: string
    body: string[]
  }[]
  effectiveDate: string
}

export function InfoPageContainer({ title, contents, effectiveDate }: Props) {
  return (
    <div className="h-full max-w-screen-md p-3 px-5 mx-auto overflow-y-auto bg-white">
      <div className="pb-4 text-center h1 font-regular">{title}</div>
      <div className="pb-4 h5 font-regular">Effective Date: {effectiveDate}</div>
      <div>
        {contents.map((item, index) => (
          <div key={index} className="pb-3">
            <div className="h5">{item.header}</div>
            <div className="font-extralight">
              {item.body.map((content, index) => {
                return (
                  <p className="px-0.5" key={index}>
                    {content}
                  </p>
                )
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
